module.exports = __webpack_public_path__ + "img/img-404.d020c689.jpg";